import * as types from './actionTypes';
import Resource from "../services/PrivateAPIResource";

export function loadChangelogSuccess(changelog) {
    return {type: types.LOAD_ALL_CHANGELOG_SUCCESS, changelog};
}


export function loadChangelog(page = 1, orderBy = 'timestamp', direction = 'DESC') {
    return function (dispatch) {
        return Resource.all(`activities?page=${page}&orderBy=${orderBy}&direction=${direction}`).then(changelog => {
            dispatch(loadChangelogSuccess(changelog))
        }).catch(error => {
            throw error;
        });
    }
}



// WEBPACK FOOTER //
// ./web/src/actions/changelogActions.js